import { PublicFcpTasksState } from "../fcpTasksSlice";

const drawerClosed = (state: PublicFcpTasksState) => {
  state.drawer = { isVisible: false, task: null };
};

export default drawerClosed;
